import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';

import { LocalStorageService } from '../service/local-storage.service';
import { LocalStorageEnum } from '../../shared/enum.ts/local-storage.enum';
import { Role } from '../../shared/enum.ts/role.enum';

const STORE_STAFF_ROLES: readonly Role[] = [Role.SUPER_ADMIN, Role.STORE_ADMIN, Role.MANAGER];

/**
 * Store-scoped staff (super admin, store admin, manager). Use for routes that
 * mirror store-admin capabilities (e.g. store, loyalty ledger) while keeping
 * {@link adminGuard} for user/customer management only.
 */
export const storeStaffGuard: CanActivateFn = () => {
  const localStorageService = inject(LocalStorageService);
  const user = localStorageService.getItem(LocalStorageEnum.USER) as { roleName?: string } | null;
  const role = user?.roleName as Role | undefined;
  return role != null && STORE_STAFF_ROLES.includes(role);
};
